import { CexOrder } from 'entities/cex-order';

import { AApiBase } from '../apiBase/AApiBase';
import { metricsAxios } from '../apiBase/axios';
import type { IBaseResponse } from '../apiBase/IBaseResponse';
import { mapError } from '../apiBase/mapError';
import { mapResponse } from '../apiBase/mapResponse';

class ApiOrders extends AApiBase {
  protected baseUrl = '/api';
  protected withHeader = true;

  /**
   * @deprecated Use placeLimitOrder from src/entities/cex-order instead.
   */
  public static placeLimitOrder = async ({
    account_id,
    order_size,
    pair_id,
    price,
    side,
  }: {
    account_id: number;
    order_size: string;
    pair_id: number;
    price: string;
    side: 'buy' | 'sell';
  }) => {
    type Return = {
      id: string;
    };

    try {
      const response = await metricsAxios.post<IBaseResponse<Return>>('/api/v1/orders', {
        account_id,
        order_size,
        pair_id,
        price,
        side,
      });

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<Return>({ error });
    }
  };

  public static cancelOrders = async ({
    account_id,
    pair_id,
    orders,
  }: {
    account_id: number;
    pair_id: number;
    orders: string[];
  }) => {
    try {
      const response = await metricsAxios.delete<IBaseResponse<any>>('/api/v1/orders', {
        data: {
          pair_id,
          account_id,
          orders,
        },
      });

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<any>({ error });
    }
  };

  public static cancelOrdersByAccount = async ({
    pair_id,
    account_id,
  }: {
    pair_id: number;
    account_id: number;
  }) => {
    try {
      const response = await metricsAxios.delete<IBaseResponse<any>>(
        `/api/v1/orders/all?pair_id=${pair_id}&account_id=${account_id}`,
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<any>({ error });
    }
  };

  /**
   *
   * @deprecated instead use src/entities/cex-order/api/queries/useGetOrders.ts
   */
  public static getOrders = async ({
    account_ids,
    bots,
    cursor,
    from,
    limit,
    pair_id,
    period,
    side,
    statuses,
    to,
  }: {
    account_ids: number[];
    bots?: string[];
    cursor?: number;
    from?: number;
    limit: number;
    pair_id: number;
    period?: string;
    side?: string;
    statuses?: string[];
    to?: number;
  }) => {
    try {
      const response = await metricsAxios.post<
        IBaseResponse<{ orders: CexOrder[]; next_cursor: number; total_count: number }>
      >('/api/v2/orders/filter', {
        account_ids,
        bots,
        cursor,
        from,
        limit,
        pair_id,
        period,
        side,
        statuses,
        to,
      });

      return mapResponse({
        data: response.data,
      });
    } catch (error: unknown) {
      return mapError<{ orders: CexOrder[]; next_cursor: number; total_count: number }>({ error });
    }
  };

  public static downloadOrders = async ({
    download_fields,
    account_ids,
    bots,
    from,
    pair_id,
    period,
    side,
    statuses,
    to,
  }: {
    download_fields: string[];
    account_ids: number[];
    bots?: string[];
    from?: number;
    pair_id: number;
    period?: string;
    side?: string;
    statuses?: string[];
    to?: number;
  }) => {
    try {
      const response = await metricsAxios.post<Blob>(
        '/api/v1/orders/filter/download',
        { download_fields, account_ids, bots, from, pair_id, period, side, statuses, to },
        {
          responseType: 'blob',
        },
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error: unknown) {
      return mapError<any>({ error });
    }
  };
}

export { ApiOrders };
